<template>
  <div>
    <div style="margin-top: 15px">
      <el-input
        placeholder="请输入正确的合同编号"
        v-model="chaxun"
        class="input-with-select"
      >
        <el-button slot="append" icon="el-icon-search" @click="GetForm()"
          >查询</el-button
        >
      </el-input>
    </div>
    <div>
      <el-table :data="tableDatA" style="width: 100%">
        <el-table-column type="expand">
          <template v-slot="props">
            <span
              v-for="modelform in props.row.encryptList"
              :key="modelform.id"
            >
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="加密锁号:" style="color: #409eff">
                  <span>{{ modelform.encryptNo }}</span>
                  <el-button size="mini" @click="handleCode(modelform)"
                    >编辑</el-button
                  >
                  <el-dialog
                    title="加密锁详情"
                    :visible.sync="dialogTableVisible"
                    append-to-body
                  >
                    <el-form
                      inline
                      class="demo-form-inline"
                      label-width="180px"
                    >
                      <el-form-item label="加密锁号">
                        <el-input
                          v-model="modelformnu.encryptNo"
                          clearable
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="内部锁号">
                        <el-input
                          v-model="modelformnu.innerEncryptNo"
                          clearable
                        ></el-input>
                      </el-form-item>
                      <br />
                      <el-form-item
                        v-for="(ruleFormBL, index) in ruleForm.module"
                        :key="index"
                        :label="ruleFormBL.name"
                      >
                        <app-ModularBJ
                          @ievent="ievent"
                          :ruleFormBL="ruleFormBL"
                          :index="Number(index)"
                          :huixianData="chuansuo"
                        ></app-ModularBJ>
                      </el-form-item>
                      <br />
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="submitCodemeter(modelformnu)"
                          >确认上传</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </el-dialog>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deletesuo(index, modelform)"
                    >删除</el-button
                  >
                </el-form-item>
                <el-form-item label="内部锁号:" style="color: #409eff">
                  <span>{{ modelform.innerEncryptNo }}</span>
                </el-form-item>
                <br />
                <span
                  v-for="model in modelform.moduleList"
                  :key="model.moduleName"
                >
                  <el-form-item label="产品名称:">
                    <span>{{ model.pname }}</span>
                  </el-form-item>
                  <el-form-item label="模块:">
                    <span>{{ model.moduleName }}</span>
                  </el-form-item>
                  <el-form-item label="节点:">
                    <span>{{ model.node }}</span>
                  </el-form-item>
                </span>
              </el-form>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="合同编号">
          <template slot-scope="scope">
            <span>{{ scope.row.contractNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位名称">
          <template slot-scope="scope">
            <span>{{ scope.row.companyName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合同日期">
          <template slot-scope="scope">
            <span>{{ scope.row.contractDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合同文件" prop="contractFile">
          <template slot-scope="scopes">
            <el-link
              :href="scopes.row.contractFile"
              target="_blank"
              :underline="false"
              v-if="scopes.row.contractFile !== ''"
            >
              <el-button
                size="mini"
                round
                type="primary"
                icon="el-icon-download"
                >下载</el-button
              >
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column label="新增">
          <template v-slot="scopes">
            <app-ModularTianjia
              :tableDatA="ruleForm.module"
              :htid="Number(scopes.row.id)"
            ></app-ModularTianjia>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-dialog
              title="合同信息编辑"
              :visible.sync="dialogVisiblecontract"
              width="50%"
            >
              <el-form label-position="left" inline :model="editfrom">
                <el-form-item label="合同编号:">
                  <el-input v-model="editfrom.contractNo"></el-input>
                </el-form-item>
                <el-form-item label="单位名称:">
                  <el-input v-model="editfrom.companyName"></el-input>
                </el-form-item>
                <el-form-item label="合同日期:">
                  <el-input v-model="editfrom.contractDate"></el-input>
                </el-form-item>
                <el-form-item label="合同文件:">
                  <div class="box">
                    <input
                      type="file"
                      name="file-1[]"
                      id="file-1"
                      @input="inputfunc"
                      class="inputfile inputfile-1"
                      data-multiple-caption="{count} files selected"
                      multiple
                    />
                    <label for="file-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="17"
                        viewBox="0 0 20 17"
                      >
                        <path
                          d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
                        />
                      </svg>
                      <span>点击修改合同</span>
                    </label>
                  </div>
                </el-form-item>
                <el-form-item label="备注:">
                  <el-input v-model="editfrom.remark"></el-input>
                </el-form-item>
                <el-form-item label="合同id:" v-if="false">
                  <el-input v-model="editfrom.id"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisiblecontract = false"
                  >取 消</el-button
                >
                <el-button
                  type="primary"
                  @click="submithetong(scope.$index, editfrom)"
                  >确 定</el-button
                >
              </span>
            </el-dialog>
            <el-button
              size="mini"
              type="danger"
              @click="deleteHT(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      editfrom: {},
      chaxun: "",
      dialogVisiblecontract: false,
      dialogTableVisible: false,
      ruleForm: {
        module: {},
      },
      modelformnu: {},
      chuansuo: {},
      tableDatA: [],
      selectedModule: [],
    };
  },
  methods: {
    handleEdit(index, row) {
      this.dialogVisiblecontract = true;
      this.editfrom = row;
    },
    ievent(data, index) {
      if (this.chuansuo.moduleList.length == 0) {
        data.forEach((e) => {
          this.chuansuo.moduleList.push(e);
        });
      } else {
        for (let j = 0; j < this.chuansuo.moduleList.length; j++) {
          if (
            this.ruleForm.module[index].id == this.chuansuo.moduleList[j].pid
          ) {
            this.chuansuo.moduleList.splice(j, 1, "");
          }
        }
        data.forEach((e) => {
          this.chuansuo.moduleList.push(e);
        });
      }
    },
    handleCode(modelform) {
      this.chuansuo = modelform;
      this.modelformnu = modelform;
      this.$http
        .post(this.$getaxiosurl("/enc/product/getAllPMInfo"))
        .then((response) => {
          this.selectedModule = [];
          if (response.data.code == "00100") {
            for (var i = 0; i < response.data.data.length; i++) {
              this.$set(this.ruleForm.module, i, response.data.data[i]);
            }
            this.dialogTableVisible = true;
          } else {
            this.tableDatA = null;
            this.$message({
              message: "没有相关合同信息",
              type: "error",
            });
          }
        });
    },
    deletesuo(index, modelform) {
      let formData = new FormData();
      formData.append("id", modelform.id);
      this.$http
        .post("http://192.168.6.213:8099/enc/encrypt/delEncrypt", formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.GetForm();
          } else {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    deleteHT(index, rows) {
      let formData = new FormData();
      formData.append("id", rows.id);
      this.$http
        .post(this.$getaxiosurl("/enc/contract/delContract"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.tableDatA = [];
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.GetForm();
          } else {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    inputfunc() {
      var inputs = document.querySelectorAll(".inputfile");
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;
        input.addEventListener("change", function (e) {
          var fileName = "";
          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          else fileName = e.target.value.split("\\").pop();
          if (fileName) label.querySelector("span").innerHTML = fileName;
          else label.innerHTML = labelVal;
        });
      });
    },
    GetForm() {
      if (this.chaxun.length <= 0) {
        return this.$message({
          showClose: true,
          message: "请输入合同编号",
          type: "error",
        });
      }
      let formData = new FormData();
      formData.append("contractNo", this.chaxun);
      this.$http
        .post(
          this.$getaxiosurl("/enc/contract/queryContractByCNo"),

          formData
        )
        .then((response) => {
          if (response.data.code == "00100") {
            if (response.data.data.length > 0) {
              this.tableDatA = [];
              console.log(response.data.data);
              if (response.data.data.length !== undefined) {
                response.data.data.forEach((element) => {
                  this.tableDatA.push(element);
                });
              } else {
                this.tableDatA.push(response.data.data);
              }
            } else {
              this.$message({
                showClose: true,
                message: "没有数据",
                type: "error",
              });
            }
          } else {
            this.tableDatA = null;
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    submithetong(index, row) {
      var fileInput = document.getElementById("file-1");
      if (
        row.companyName.length <= 0 ||
        row.contractDate.length <= 0 ||
        row.contractNo.length <= 0
      ) {
        return this.$message({
          showClose: true,
          message: "不能为空",
          type: "error",
        });
      }
      var formData = new FormData();
      if (fileInput.files.length == 0) {
        formData.append("contractId", row.id);
        formData.append("contractNo", row.contractNo);
        formData.append("remark", row.remark);
        formData.append("companyName", row.companyName);
        formData.append("contractDate", row.contractDate);
      } else {
        formData.append("contractId", row.id);
        formData.append("contractNo", row.contractNo);
        formData.append("remark", row.remark);
        formData.append("companyName", row.companyName);
        formData.append("contractDate", row.contractDate);
        formData.append(
          "contractFile",
          fileInput.files[0],
          fileInput.files[0].name
        );
      }
      this.$http
        .post(this.$getaxiosurl("/enc/contract/editContract"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: response.data.msg,
              type: "success",
              duration: 8000,
            });
            this.dialogVisiblecontract = false;
            this.GetForm();
          } else {
            if (response.data.code != "00100") {
              this.$message({
                showClose: true,
                message: response.data.msg,
                type: "error",
              });
            }
          }
        });
    },
    submitCodemeter(modelformnu) {
      if (
        modelformnu.encryptNo.length <= 0 ||
        modelformnu.innerEncryptNo.length <= 0
      ) {
        return this.$message({
          showClose: true,
          message: "加密锁号,内部锁号不能为空",
          type: "error",
        });
      }
      let modulist = [];
      for (let i = 0; i < this.chuansuo.moduleList.length; i++) {
        if (this.chuansuo.moduleList[i] != "") {
          modulist.push(this.chuansuo.moduleList[i]);
        }
      }
      let Params = {
        encryptNo: modelformnu.encryptNo,
        innerEncryptNo: modelformnu.innerEncryptNo.trim(),
        encryptId: this.chuansuo.id,
        modules: modulist,
      };
      this.$http
        .post(
          this.$getaxiosurl("/enc/contract/editLock"),
          JSON.stringify(Params)
        )
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: response.data.msg,
              type: "success",
            });
            this.dialogTableVisible = false;
            this.GetForm();
          } else {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
  },
};
</script>
<style scoped>
.box {
  line-height: 20px !important;
}
.grid-a-content-a-Width {
  border-radius: 4px;
  width: 100%;
}
.el-checkbox {
  color: #000000;
  margin: 40px;
}
h3 {
  text-align: center;
}
.el-input {
  padding-bottom: 1px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.js .inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  max-width: 80%;
  font-size: 1.25rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}
.no-js .inputfile + label {
  display: none;
}
.inputfile:focus + label,
.inputfile.has-focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}
.inputfile + label svg {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.25em;
}
.inputfile-1 + label {
  color: #f1e5e6;
  background-color: #409eff;
}
.inputfile-1:focus + label,
.inputfile-1.has-focus + label,
.inputfile-1 + label:hover {
  background-color: #67c23a;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 160px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 30%;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>